import { Table } from '@mui/material';

const BSTable = ({ children, ...props }) => {
  return <Table {...props}>{children}</Table>;
};

export default BSTable;
